module.exports = __webpack_public_path__ + "img/9788963708324.16af3543.jpg";